<template>
  <div class="edit-template-page w-full flex flex-1 flex-col min-h-0">
    <!-- Show inbox header banner when editing from inbox context -->
    <setting-intro-banner
      v-if="shouldShowHeader && inbox"
      :header-title="`${inbox.name} (${inbox.phone_number})`"
    />

    <div
      class="wizard-body w-[100%] flex-1 min-h-0 max-w-[100%] overflow-y-auto"
    >
      <div class="w-full">
        <whatsapp-edit-template
          :submit-in-progress="false"
          :submit-button-text="$t('WHATSAPP_TEMPLATES.ADD.EDIT_TEXT')"
        />
      </div>
    </div>
  </div>
</template>
  
  <script>
  import alertMixin from 'shared/mixins/alertMixin';
  import SettingIntroBanner from 'dashboard/components/widgets/SettingIntroBanner';
  import WhatsappEditTemplate from '../WhatsappEditTemplate.vue';

  // import Wizard from '../../../../../components/ui/Wizard.vue';
  
  export default {
    components: {
      SettingIntroBanner,
      WhatsappEditTemplate,
    },
    mixins: [alertMixin],
  
  data() {
    return {
      enabledFeatures: {},
    };
  },
  computed: {
    shouldShowHeader() {
      // Show header only when NOT coming from standalone context
      return !this.$route.query.standalone;
    },
    inbox() {
      // Get inbox data from store
      return this.$store.getters['inboxes/getInbox'](this.$route.params.inboxId);
    },
  },
  props: {
    // inbox: {
    //   type: Object,
    //   required: true
    // },
    // currentAccountId: {
    //   type: String,
    //   required: true,
    // },
  },
  async mounted() {
    this.template_data = this.$route.params.template_data;
    // Ensure inboxes are loaded so we can access inbox data
    await this.$store.dispatch('inboxes/get');
  },
  methods: {},
  };
  </script>
  <style scoped>
  .edit-template-page {
    min-height: 0;
  }
  </style>